// We cleanup the localStorage images. We can remove it in the followup MR

/* MUI */
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { debug as logger } from 'application/Shared/Utils';

/* React */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

/* Theme */
import { StylesAndColors } from 'theme/StylesAndColors';

import App from './application/App/Container';
import i18n from './i18n';
import './removeImageLocalStorageImages';
import { initSentry } from './sentry';
import { setupStore } from './store/store';

// We init Sentry early possible. We set the configureScope in the App.jsx once we get the session.
initSentry(
    process.env.REACT_APP_SENTRY_DNS,
    process.env.REACT_APP_ENV,
    process.env.REACT_APP_VERSION
);

const store = setupStore();
const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
    <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <StylesAndColors>
                    <App />
                </StylesAndColors>
            </I18nextProvider>
        </Provider>
    </LocalizationProvider>
);

logger.info(
    'App started',
    process.env.REACT_APP_ENV,
    process.env.REACT_APP_VERSION
);
